/**
 * El precio que ESTE socio paga por ESTE producto — el resolutor, único.
 * Gemelo del backend: modules/v1/products/pricing_services.price_for_member_line.
 *
 * `cost_line` del socio («Defecto»/«Segunda»/«Tercera») elige entre `price`,
 * `price_second_line` y `price_third_line`. Línea vacía o a 0 → tarifa. En
 * productos a peso el precio (y su línea) es €/GRAMO.
 *
 * Vivía en `DispenserComponents/pricing.js`, así que la Sala no podía usarlo y
 * congelaba la tarifa mientras el cobro aplicaba la línea — el ticket decía un
 * precio y el monedero se movía con otro (descuadre CRUO, 03-09-2026). El mismo
 * destino que tuvo el descuento del socio hasta el #634. Regla desde entonces:
 * todo precio de venta que se pinte o congele sale de aquí.
 */
// spec: saldo-pagos-caja#lineas-de-coste
// «El precio del socio se decide en UN sitio» · «En productos a peso, el precio de
// línea es €/GRAMO» · «línea vacía o a 0 → tarifa normal».
// Gemelo BE: modules/v1/products/pricing_services.py → price_for_member_line.
export function effectiveUnitPrice(product, costLine) {
  // `price: null` también es «sin precio»: Number(null) da 0 y colaría un
  // producto gratis en silencio (verificación 04-09) — el gemelo BE revienta.
  const base = product?.price == null ? NaN : Number(product.price);
  if (!Number.isFinite(base)) {
    // Un producto sin `price` en el objeto NO es un producto gratis: es un bug
    // del llamador (el backend revienta en este caso). Se avisa y se pinta 0
    // para no tumbar la pantalla; el test del helper fija este aviso.
    console.error('effectiveUnitPrice: producto sin price', product?.id);
    return 0;
  }
  let linePrice = null;
  if (costLine === 'Segunda') linePrice = product?.price_second_line;
  else if (costLine === 'Tercera') linePrice = product?.price_third_line;
  if (linePrice == null) return base;
  const n = Number(linePrice);
  return n > 0 ? n : base;
}
